<div class="flex--row spacing--margin-bottom">
  <div class="spacing--margin-right">
    <mat-chip-listbox>
      @for (cropField of selectedCropFields(); track cropField.id) {
        <mat-chip-option
          [selectable]="false"
          [removable]="selectedCropFieldsCount() > 1 && !readOnly()"
          (removed)="deselectCropField(cropField)"
        >
          <b>{{ cropField.name }}</b> {{ cropField.areaInHectare }} ha
          @if (selectedCropFieldsCount() > 1 && !readOnly()) {
            <mat-icon matChipRemove data-test="crop-remove">cancel</mat-icon>
          }
        </mat-chip-option>
      }
    </mat-chip-listbox>
  </div>
</div>
